import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useContext } from 'react';
import { formStateContext } from '../../context';
export var useCardFieldUpdate = function useCardFieldUpdate(name, transformer) {
  var _useContext = useContext(formStateContext),
    _useContext2 = _slicedToArray(_useContext, 2),
    setState = _useContext2[1];
  return useCallback(function (value) {
    return setState(name, transformer(value));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [name, setState] // do not put transformer into deps
  );
};
export var useCardFields = function useCardFields() {
  var _useContext3 = useContext(formStateContext),
    _useContext4 = _slicedToArray(_useContext3, 1),
    state = _useContext4[0];
  return state;
};